export var SocketStatus;
(function (SocketStatus) {
    SocketStatus["ACTUAL"] = "Actual";
    SocketStatus["UPDATING"] = "Updating";
    SocketStatus["ERROR"] = "Error";
})(SocketStatus || (SocketStatus = {}));
/** COMMON TYPES, ENUMS AND ENTITIES */
export var ConfigurationElementType;
(function (ConfigurationElementType) {
    ConfigurationElementType["Unknown"] = "Unknown";
    ConfigurationElementType["Impeller"] = "Impeller";
    ConfigurationElementType["Sparger"] = "Sparger";
    ConfigurationElementType["Bioreactor"] = "Bioreactor";
    ConfigurationElementType["Name"] = "Name";
    ConfigurationElementType["Description"] = "Description";
})(ConfigurationElementType || (ConfigurationElementType = {}));
export var BioprocessParameter;
(function (BioprocessParameter) {
    BioprocessParameter[BioprocessParameter["Kla"] = 0] = "Kla";
    BioprocessParameter[BioprocessParameter["Power"] = 1] = "Power";
    BioprocessParameter[BioprocessParameter["MixingTime"] = 2] = "MixingTime";
})(BioprocessParameter || (BioprocessParameter = {}));
export var EngineResultType;
(function (EngineResultType) {
    EngineResultType["Result0D"] = "Result0D";
    EngineResultType["Result1D"] = "Result1D";
    EngineResultType["Result2D"] = "Result2D";
    EngineResultType["ResultMetadata"] = "ResultMetadata";
})(EngineResultType || (EngineResultType = {}));
export var PsGlobalEntityType;
(function (PsGlobalEntityType) {
    PsGlobalEntityType["Scenario"] = "Scenario";
    PsGlobalEntityType["ResultSet"] = "ResultSet";
})(PsGlobalEntityType || (PsGlobalEntityType = {}));
export var ScenarioEntityType;
(function (ScenarioEntityType) {
    ScenarioEntityType["Configuration"] = "Configuration";
    ScenarioEntityType["SimpleMetric"] = "SimpleMetric";
    ScenarioEntityType["RelativeMetric"] = "RelativeMetric";
})(ScenarioEntityType || (ScenarioEntityType = {}));
export var MiscType;
(function (MiscType) {
    MiscType["Parameter"] = "Parameter";
})(MiscType || (MiscType = {}));
export var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus["Online"] = "online";
    ConnectionStatus["Disconnected"] = "disconnected";
    ConnectionStatus["Offline"] = "offline";
})(ConnectionStatus || (ConnectionStatus = {}));
/**
 ************************************************************************
 **                                                                    **
 **                          CALCULATION RESULTS                       **
 **                                                                    **
 ************************************************************************
 **/
export var PsCalculationResultsDataItemState;
(function (PsCalculationResultsDataItemState) {
    PsCalculationResultsDataItemState["UniqueSolutions"] = "UniqueSolutions";
    PsCalculationResultsDataItemState["TooManyDegreesOfFreedom"] = "TooManyDegreesOfFreedom";
    PsCalculationResultsDataItemState["Conflict"] = "Conflict";
    PsCalculationResultsDataItemState["Pending"] = "Pending";
    PsCalculationResultsDataItemState["NoOptimum"] = "NoOptimum";
    PsCalculationResultsDataItemState["Undefined"] = "Undefined";
    PsCalculationResultsDataItemState["MultipleSolutions"] = "MultipleSolutions";
    PsCalculationResultsDataItemState["IncompleteDependencySet"] = "IncompleteDependencySet";
})(PsCalculationResultsDataItemState || (PsCalculationResultsDataItemState = {}));
export var PsCalculationResultsDataItemText;
(function (PsCalculationResultsDataItemText) {
    PsCalculationResultsDataItemText["UniqueSolutions"] = "Unique Solutions";
    PsCalculationResultsDataItemText["TooManyDegreesOfFreedom"] = "Too many degrees of freedom";
    PsCalculationResultsDataItemText["Conflict"] = "Conflict";
    PsCalculationResultsDataItemText["Pending"] = "Pending";
    PsCalculationResultsDataItemText["NoOptimum"] = "No optimum";
    PsCalculationResultsDataItemText["Undefined"] = "Undefined";
    PsCalculationResultsDataItemText["MultipleSolutions"] = "Multiple Solutions";
    PsCalculationResultsDataItemText["IncompleteDependencySet"] = "Incomplete dependency set";
})(PsCalculationResultsDataItemText || (PsCalculationResultsDataItemText = {}));
export var GraphItems;
(function (GraphItems) {
    GraphItems["lines"] = "lines";
    GraphItems["contours"] = "contours";
})(GraphItems || (GraphItems = {}));
export const LONG_CALCULATION_DELAY = 30000;
